import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { TRequestDto } from './dto/RequestDto';

/**
 * Список акций домофонии по всем городам
 * {@link https://master.api-content.sandbox.d2c.r-one.io/docs/v1#/%D0%90%D0%BA%D1%86%D0%B8%D0%B8%20%D0%B4%D0%BE%D0%BC%D0%BE%D1%84%D0%BE%D0%BD%D0%B8%D0%B8/get_v1_domofon_action Documentation}
 */
export const domofonAction = (queryParams: TRequestDto = {}): IRequest => ({
    uri: '/v1/domofon-action',
    method: 'GET',
    queryParams,
    withProvider: true,
});
